import React from "react";
import { Box, Stack, Typography } from "digiwash-components";

interface PropsType {
  title: string;
  subtitle: string;
}

function ServiceTitle(props: PropsType) {
  return (
    <Box
      br="s"
      bg="common.white"
      style={{
        width: "100%",
        height: 60,
        justifyContent: "center",
      }}
    >
      <Stack distribution="center">
        <Box style={{ flex: 1 }} px="s">
          <Typography
            ff="mainMedium"
            alignment="center"
            color="common.black"
            fs="xm"
          >
            {props.title}
          </Typography>
          {props.subtitle ? (
            <Typography
              style={{ flexShrink: 1 }}
              alignment="center"
              ellipsizeMode="tail"
              numberOfLines={1}
              color="gray.light950"
              ff="mainLight"
              fs="xm"
            >
              {props.subtitle}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
}

export default ServiceTitle;
